import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SessionService {
  private readonly KEY = 'cc_session_id';

  getSessionId(): string {
    let sessionId = sessionStorage.getItem(this.KEY);

    if (!sessionId) {
      sessionId = crypto.randomUUID();
      sessionStorage.setItem(this.KEY, sessionId);
    }

    return sessionId;
  }
}
